import { Paper, PaperProps } from '@mantine/core'
import { ReactNode } from 'react'

type DataUsageIndicatorWrapperProps = PaperProps & {
  children: ReactNode
}

export const DataUsageIndicatorWrapper = ({
  children,
  ...props
}: DataUsageIndicatorWrapperProps) => {
  return (
    <Paper w="100%" bg="gray.1" p="xs" {...props}>
      {children}
    </Paper>
  )
}
